import { FC } from "react";
import { observer } from "mobx-react";
import { Box, CircularProgress } from "@mui/material";

import HomePage from "../components/ui/home/HomePage";
import ExtendedHomePage from "../components/ui/home-v2/ExtendedHomePage";
import { useAppStore } from "../hooks/useAppStore";
import { useConfigFlagsWait } from "../hooks/useConfigFlagsWait";

const Home: FC = observer(() => {
  const appStore = useAppStore();
  // Falls back to the legacy page if the flags never arrive
  const { isWaiting } = useConfigFlagsWait();

  if (isWaiting) {
    return (
      <main className="grow flex flex-col bg-hex-gray-100 h-[calc(100%-6rem)] overflow-y-auto overflow-x-hidden">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            width: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      </main>
    );
  }

  if (appStore.isHomeV2Enabled) {
    return <ExtendedHomePage />;
  }

  return <HomePage />;
});

export default Home;
